import { Auth } from 'aws-amplify'
import { IPricesQuery, ShopIdentifier } from '@/client/types'
import { api } from '@/client/utils'

const LOCALE_TO_SHOP_ID: Record<string, number> = {
  de: ShopIdentifier.DE,
  uk: ShopIdentifier.UK,
  fr: ShopIdentifier.FR,
  nl: ShopIdentifier.NL,
  it: ShopIdentifier.IT,
  au: ShopIdentifier.AU,
  us: ShopIdentifier.US,
  es: ShopIdentifier.ES,
  pl: ShopIdentifier.PL,
  dk: ShopIdentifier.DK,
  se: ShopIdentifier.SE
}

export const currentShopId = LOCALE_TO_SHOP_ID[process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'es'] ?? 10
export const getPrices = async (locale: string) => {
  const url = `/${currentShopId}/${locale}/price`
  const { data } = await api.get<IPricesQuery>(url)
  return data
}

export const updatePrices = async (locale: string, data) => {
  let url: string
  try {
    const { attributes } = await Auth.currentAuthenticatedUser()
    const customerId = attributes['custom:customer_id']
    url = `/${currentShopId}/${locale}/price/${customerId}`
  } catch {
    // User not authenticated, fallback URL
    url = `/${currentShopId}/${locale}/price`
  }
  return api.post<IPricesQuery>(url, data)
}
